import React, { useState, useEffect } from 'react';
import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'https://drvivara.cloud/api' });
api.interceptors.request.use(c => { const t = localStorage.getItem('token'); if (t) c.headers.Authorization = `Bearer ${t}`; return c; });

const FeatureControls = () => {
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => { fetchFlags(); }, []);

  const fetchFlags = async () => {
    try {
      const res = await api.get('/feature-flags');
      if (res.data.success) setFlags(res.data.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const updateFlag = async (feature, data) => {
    try {
      const res = await api.put(`/feature-flags/${feature}`, data);
      if (res.data.success) { setMessage('Updated successfully'); fetchFlags(); }
    } catch (e) { setMessage('Update failed'); }
  };

  if (loading) return <div className="p-8 text-center text-gold">Loading...</div>;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gold mb-6">Feature Controls</h1>
      {message && <p className="text-green-400 mb-4">{message}</p>}
      <div className="space-y-6">
        {flags.map(flag => (
          <div key={flag.feature} className="bg-gray-900 rounded-lg p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-light">{flag.display_name}</h3>
              <select
                value={flag.status}
                onChange={(e) => updateFlag(flag.feature, { status: e.target.value })}
                className="bg-gray-800 text-light border border-gray-600 rounded px-3 py-1"
              >
                <option value="enabled">Enabled</option>
                <option value="disabled">Disabled</option>
                <option value="coming_soon">Coming Soon</option>
              </select>
            </div>
            {flag.status === 'coming_soon' && (
              <div className="space-y-2">
                <div>
                  <label className="text-sm text-gray-400 block">Coming Soon Message</label>
                  <input
                    type="text" value={flag.coming_soon_message || ''}
                    onChange={(e) => setFlags(prev => prev.map(f => f.feature === flag.feature ? { ...f, coming_soon_message: e.target.value } : f))}
                    className="w-full bg-gray-800 text-light border border-gray-600 rounded px-3 py-2 mt-1"
                  />
                </div>
                <div>
                  <label className="text-sm text-gray-400 block">Launch Date</label>
                  <input
                    type="date" value={flag.launch_date ? flag.launch_date.split('T')[0] : ''}
                    onChange={(e) => setFlags(prev => prev.map(f => f.feature === flag.feature ? { ...f, launch_date: e.target.value } : f))}
                    className="w-full bg-gray-800 text-light border border-gray-600 rounded px-3 py-2 mt-1"
                  />
                </div>
                <button
                  onClick={() => updateFlag(flag.feature, { coming_soon_message: flag.coming_soon_message, launch_date: flag.launch_date })}
                  className="bg-gold text-dark px-4 py-2 rounded mt-2 font-semibold"
                >Save</button>
              </div>
            )}
            <div className="mt-2">
              <span className={`px-2 py-1 rounded text-xs ${flag.status === 'enabled' ? 'bg-green-600' : flag.status === 'disabled' ? 'bg-red-600' : 'bg-yellow-600'}`}>
                {flag.status}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureControls;
